import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Dashboard from './components/Dashboard/Dashboard';
import KonvaCanvasEditor from './components/Editor/KonvaCanvasEditor';
import RenderHistory from './components/RenderHistory/RenderHistory';
import Navbar from './components/Layout/Navbar';

const AppContent: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        {isAuthenticated && <Navbar />}
        <Routes>
          <Route 
            path="/login" 
            element={!isAuthenticated ? <Login /> : <Navigate to="/dashboard" />} 
          />
          <Route 
            path="/register" 
            element={!isAuthenticated ? <Register /> : <Navigate to="/dashboard" />} 
          />
          <Route 
            path="/dashboard" 
            element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/editor/:templateId" 
            element={isAuthenticated ? <KonvaCanvasEditor /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/editor" 
            element={isAuthenticated ? <KonvaCanvasEditor /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/template/:templateId/renders" 
            element={isAuthenticated ? <RenderHistory /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/" 
            element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} 
          />
        </Routes>
      </div>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
